/**
 * One-shot breadcrumbs for playlist open → route → render.
 * Always captured in the support diagnostic snapshot (fleet + ticket logs).
 */

import { diagnosticLog } from './diagnosticLogger';

export type PlaylistNavPhase = 'click' | 'route' | 'render';

const flowStarts = new Map<string, number>();

function flowKey(playlistId: string, source?: string): string {
  return `${source || 'unknown'}::${playlistId}`;
}

export function logPlaylistNavBreadcrumb(
  phase: PlaylistNavPhase,
  playlistId: string,
  details?: Record<string, unknown>,
): void {
  try {
    const id = String(playlistId || '').trim() || '(missing-id)';
    const source = typeof details?.source === 'string' ? details.source : undefined;
    const key = flowKey(id, source);
    const now = Date.now();

    if (phase === 'click') {
      flowStarts.set(key, now);
    }

    const startedAt = flowStarts.get(key);
    const elapsedMs = startedAt != null ? now - startedAt : undefined;

    diagnosticLog('info', 'navigation', `playlist-open:${phase}`, {
      playlist_id: id,
      source: source ?? null,
      phase,
      elapsed_ms: elapsedMs ?? null,
      ...details,
    });

    if (phase === 'render') {
      flowStarts.delete(key);
    }
  } catch {
    /* never propagate */
  }
}
